import EmisionGuiaV3 from '@/pages/guias/EmisionGuiaV3.jsx';
import GuiasListado from '@/pages/guias/GuiasListado.jsx';
import GuiasBuscar from '@/pages/guias/GuiasBuscar.jsx';
import GuiaDetalle from '@/pages/Guias/GuiaDetalle.jsx';
import GuiaValorizar from '@/pages/Guias/GuiaValorizar.jsx';

export const guiasRoutes = [
  {
    path: '/guias',
    label: 'Listado de Guías',
    component: GuiasListado,
  },
  {
    path: '/guias/consulta',
    label: 'Consulta de Guías',
    component: GuiasListado,
  },
  {
    path: '/guias/emitir',
    label: 'Emisión de Guía',
    component: EmisionGuiaV3,
  },
  {
    path: '/guias/buscar',
    label: 'Búsqueda de Guías',
    component: GuiasBuscar,
  },
  {
    path: '/guias/:id',
    label: 'Detalle de Guía',
    component: GuiaDetalle,
  },
  {
    path: '/guias/:id/valorizar',
    label: 'Valorización de Guía',
    component: GuiaValorizar,
  },
];
